import { render } from "./Stack.vue?vue&type=template&id=bd901db6&scoped=true"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"

import "./Stack.vue?vue&type=style&index=0&id=bd901db6&scoped=true&lang=css"

import exportComponent from "/Volumes/ZTDisk/Mx_Zone/projects/xs/labfront/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd901db6"]])

export default __exports__